<template>
<div>
    <div class="modal-body syarat-ketentuan mt-2">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Penggunaan layanan irsmarket.com tunduk pada syarat dan ketentuan penjualan (“Syarat dan Ketentuan”). Dengan mendaftarkan diri Anda sebagai pengguna irsmarket.com (selanjutnya disebut member) dan mengakses serta menggunakan fitur dan layanan di irsmarket.com (termasuk melakukan Penjualan dan/atau Pembelian), berarti Anda setuju untuk terikat pada Syarat dan Ketentuan Transaksi ini termasuk setiap perubahan atas Syarat dan Ketentuan Transaksi yang akan tersedia di dalam halaman ini. Syarat dan Ketentuan Transaksi ini akan mengikat Anda selama Anda mengakses, menggunakan fitur dan layanan di irsmarket.com serta melakukan Penjualan dan/atau Pembelian di irsmarket.com<p/>

          <p><strong>IRSMarket sebagai wadah</strong> untuk mempertemukan penjual dan pembeli guna melakukan transaksi produk digital, untuk itu segala bentuk resiko yang timbul dalam transaksi termasuk namun tidak terbatas pada keuntungan ataupun kerugian bukanlah merupakan tanggung jawab dari IRSMarket.</p> <p>Anda wajib membaca dan memahami Syarat dan Ketentuan Transaksi ini (termasuk perubahannya).</p>

          <span class="h1-modal"><strong>1. TENTANG IRSMARKET.COM</strong></span>
          <ol>
            <li type="a">
              <p>
                Irsmarket.com adalah market place yang dikembangkan oleh PT. Aviana Sinar Abadi yang menyediakan layanan host to host bagi para server player di Indonesia.
              </p>
            </li>
            <li type="a">
              <p>
                PT Aviana Sinar Abadi adalah perusahaan yang bergerak di bidang IT dengan kantor pusat di kota Denpasar.
              </p>
            </li>
            <li type="a">
              <p>
                Market Place adalah pasar elektronik yang melakukan transaksi jual beli barang dan jasa produk digital.
              </p>
            </li>
            <li type="a">
              <p>
                Server Player adalah pelaku bisnis jual beli produk operator seluler dan layanan jasa pembayaran online (PPOB) dan produk digital lainnya
              </p>
            </li>
            <li type="a">
              <p>
                Host to host adalah sebuah sistem transaksi jual beli antar server player dengan menggunaan aplikasi tertentu.
              </p>
            </li>
          </ol>
          <span class="h1-modal"><strong>2. DEFINISI</strong></span>
          <ol>
            <li type="a">
              Pengguna adalah setiap orang yang memasuki atau menggunakan situs irsmarket.com
            </li>
            <li type="a">
              Pembeli adalah orang dan/atau badan hukum (usaha) yang membeli barang atau jasa di irsmarket.com.
            </li>
            <li type="a">
              Produk adalah barang atau jasa yang diperjualbelikan di irsmarket.com
            </li>
            <li type="a">
              Informasi Penjualan adalah seluruh bentuk informasi yang menerangkan deskripsi produk tertentu di irsmarket.com
            </li>
            <li type="a">
              Klaim adalah tuntutan yang disampaikan oleh Pembeli dikarenakan produk yang sudah dibeli diterima dalam kondisi, kualitas dan kuantitas yang berbeda dari Informasi Penjualan.
            </li>
            <li type="a">
              Retur adalah proses pengembalian produk akibat klaim yang dilakukan salah satu pihak terhadap pihak lainnya.
            </li>
            <li type="a">
              Pengelolaan situs irsmarket.com meliputi aktivitas yang tidak terbatas pada pemeliharaan situs, layanan pengguna dan promosi.
            </li>
            <li type="a">
              Payment gateway adalah layanan dalam industri e-dagang yang digunakan irsmarket untuk otorisasi pembayaran dengan transfer dana dan/atau berbagai metode pembayaran langsung lainnya
            </li>
          </ol>
          <span class="h1-modal"><strong>3. PERSYARATAN</strong></span>
          <ol>
            <li type="a">
              Untuk melakukan transaksi di irsmarket.com pengguna hanya dapat menggunakan software pulsa IRS.
            </li>
            <li type="a">
              Software pulsa IRS yang dapat digunakan transaksi di irsmarket.com adalah versi yang sudah di update dengan fitur irsmarket.
            </li>
          </ol>
          <span class="h1-modal"><strong>4. LARANGAN</strong></span>
          <p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Pengguna dilarang untuk menciptakan dan/atau menggunakan perangkat lunak/keras, fitur dan/atau alat lainnya yang bertujuan untuk melakukan manipulasi pada sistem irsmarket.com yang berujung pada rusaknya sistem irsmarket.com, pengambilan informasi dari Pengguna lain, dan akibat atau penyalahgunaan lain yang secara wajar dapat dinilai merugikan irsmarket.com dan Penggunanya.</p>
          <span class="h1-modal"><strong>5. KERAHASIAAN</strong></span>
          <ol>
            <li type="a">
              Irsmarket.com bertanggungjawab atas pengumpulan data dan informasi Pengguna dan perlindungannya setiap waktu. Kebijakan ini berlaku bagi seluruh Pengguna irsmarket.com, tanpa kecuali.
            </li>
            <li type="a">
              Penggunaan fitur registrasi dengan nomor hp, login dengan email, irsmarket.com dan secure socket layer (SSL) merupakan upaya irsmarket dalam melindungi privasi Pengguna.
            </li>
            <li type="a">
              Irsmarket berhak menggunakan data dan informasi Pengguna situs demi meningkatkan mutu dan pelayanan di irsmarket.com serta keperluan promosi dari irsmarket.com
            </li>
            <li type="a">
              Irsmarket tidak bertanggungjawab terhadap berpindahnya data dan informasi Pengguna ke pihak lain, akibat pertukaran data yang dilakukan sendiri di antara Pengguna atau akibat dari pihak ketiga yang melakukan aktivitas pengambilan data tanpa ijin melalui praktek-praktek ilegal.
            </li>
          </ol>
          <span class="h1-modal"><strong>6. PENGUMPULAN INFORMASI</strong></span>
          <ol>
            <li type="a">
              Irsmarket.com tidak mengalihkan dan/atau menyerahkan data dan informasi pengguna yang dikumpulkan kepada pihak ketiga.
            </li>
            <li type="a">
              Data dan Informasi pengguna, akan membantu irsmarket dalam menyediakan informasi produk baru yang diminati atau dibutuhkan kembali.
            </li>
            <li type="a">
              Harga dan ketersediaan Produk dapat berubah setiap saat. Setiap ada perubahan harga dan ketersediaan Produk tersebut, penjual akan menyampaikan pengumuman di irsmarket.com mengenai perubahan tersebut kepada pengguna lainnya.
            </li>
            <li type="a">
              Data dan Informasi pengguna digunakan untuk keamanan, data statistik, analisa pemasaran, manajemen sistem informasi, penagihan pembayaran, pemeliharaan dan pengembangan data, survei, membantu irsmarket.com dalam meningkatkan layanan kepada pengguna, melalui identifikasi permintaan dan kebutuhan pengguna.
            </li>
            <li type="a">
              Karena perintah peraturan perundang-undang dan/atau keputusan pengadilan, irsmarket dapat memberikan data dan informasi tentang pengguna kepada pemerintah atau pihak ketiga atau badan resmi lainnya yang terkait. Lebih lanjut, irsmarket juga akan menggunakan atau memberikan data dan informasi pengguna sebagaimana diizinkan sesuai hukum melindungi hak atau milik irsmarket.com atau para penggunanya.
            </li>
          </ol>
          <span class="h1-modal"><strong>7. PENJUALAN dan PEMBELIAN</strong></span>
          <ol>
            <li type="a">
              Untuk melakukan transaksi, Pengguna wajib mendaftarkan akun di irsmarket  dan mengisi data diri yang diminta.
            </li>
            <li type="a">
              Pengguna bertanggungjawab menjaga kerahasiaan data akun dan kata sandi milik Pengguna.
            </li>
            <li type="a">
              Irsmarket.com tidak akan meminta kata sandi Pengguna untuk alasan apapun, sehingga Pengguna dihimbau untuk tidak memberikan kata sandi akun kepada pihak manapun yang mengaku sebagai pihak irsmarket.com.
            </li>
            <li type="a">
              Dalam keadaan normal, jumlah ketersediaan Produk yang tertera di irsmarket.com menggambarkan ketersedian Produk yang dijual.
            </li>
            <li type="a">
              Saat melakukan pembelian Produk, Pembeli setuju bahwa Pembeli telah membaca, memahami, dan menyetujui seluruh informasi/deskripsi yang tertera sebelum melakukan pembelian Produk.
            </li>
            <li type="a">
              Saat melakukan pembelian Produk, Pembeli mengakui bahwa telah memilih dengan baik suplier dan produk yang akan di transaksikan. Irsmarket berupaya semaksimal mungkin menampilkan produk yang di butuhkan pembeli sesuai perkembangan dan perubahan dari kondisi pasar.
            </li>
            <li type="a">
              Semua produk yang akan ditransaksikan, semua masuk ke halaman produk pembelian terlebih dahulu untuk selanjutnya di atur aktivasi dan prioritasnya oleh pembeli.
            </li>
            <li type="a">
              Harga yang di terima pembeli adalah harga yang telah di sepakati dengan penjual. Kesepakatan harga dapat dilakukan tanpa persetujuan irsmarket.com.
            </li>
            <li type="a">
              Klaim transaksi oleh pembeli dapat dilakukan langsung kepada penjual melalui fsilitas komunikasi yang disediakan oleh irsmarket.com
            </li>
            <li type="a">
              Setiap terjadi perbedaan transaksi (dispute) yang timbul antara Penjual, pembeli dan IRS Market, maka Penjual ataupun Pembeli dalam IRS Market wajib melaporkan hal tersebut kepada IRS Market ataupun PT Aviana Sinar Abadi Tbk dalam waktu selambat-lambatnya 1x24 jam setelah transaksi dilakukan. Namun apabila Laporan diajukan lebih dari waktu yang telah ditentukan tersebut maka IRS Market (PT Aviana Sinar Abadi Tbk) berhak menolak Laporan dan menganggap tidak ada kendala / perbedaan transaksi yang terjadi di IRS Market, selanjutnya Pengguna wajib dan setuju membebaskan IRS Market (PT Aviana Sinar Abadi Tbk) dari segala bentuk tuntutan ganti rugi atas kendala atau perbedaan transaksi yang timbul setelah lewat dari jangka waktu dimaksud.
            </li>
            <li type="a">
              Seluruh produk yang ditampilkan dan/atau dijual melalui IRS Market merupakan produk yang Legal dan diperbolehkan sesuai dengan ketentuan hukum yang berlaku di Indonesia. Apabila terjadi penyalahgunaan produk oleh Pengguna IRS Market, baik Pembeli maupun Penjual, maka seluruh tanggung jawab sepenuhnya berada pada pihak pengguna tersebut. IRS Market tidak bertanggung jawab atas segala bentuk pelanggaran hukum yang timbul akibat penyalahgunaan produk, Penjual atau Pembeli wajib dan setuju untuk membebaskan IRS Market dari segala bentuk tuntutan hukum baik Pidana maupun Perdata serta hukum lainnya.
            </li>
            <li type="a">
              Pembeli yang berbadan hukum dapat meakukan permintaan faktur kepada penjual tanpa persetujuan pihak irsmarket.com
            </li>
          </ol>
          <span class="h1-modal"><strong>8. DEPOSIT</strong></span>
          <ol>
            <li type="a">
              Pengguna wajib mengisi form Deposit pada sistem IRS Market.
            </li>
            <li type="a">
              Pengguna wajib membaca dan menyetujui syarat Deposit dengan mencentang dan meng-klik tombol setuju pada kolom Deposit yang telah disediakan.
            </li>
            <li type="a">
              Pengguna menjamin dana yang di depositkan bersumber dan atau diperoleh dari suatu perbuatan yang tidak terlarang termasuk namun tidak terbatas pada Tindak Pidana Pencucian Uang (TPPU).
            </li>
            <li type="a">
              Apabila terjadi pelanggaran sebagaimana termuat dalam poin c diatas maka, Pengguna wajib membebaskan IRS Market dari segala bentuk tuntutan termasuk namun tidak terbatas pada segala bentuk tuntutan hukum baik Pidana maupun Perdata serta hukum lainnya.
            </li>
             <li type="a">
              Secara berkala, irsmarket.com akan melakukan proses pemeriksaan bukti transfer ke Bank BCA, Mandiri dan sistem pembayaran lainnya pada hari kerja (Senin – Jumat) dan jam operasional 08:00 WIB – 17:00 WIB.Jika dalam 2×24 jam Pembeli tidak melakukan pembayaran, maka irsmarket berhak melakukan pembatalan permintaan deposit.
            </li>
          </ol>
          <span class="h1-modal"><strong>9. RETUR</strong></span>
          <ol>
            <li type="a">
              Penggantian atas transaksi yang tidak valid dapat dilakukan dengan mengirimkan permintaan kepada penjual tanpa persetujuan irsmarket.
            </li>
            <li type="a">
              Klaim untuk keperluan retur untuk mendapatkan produk pengganti, harus dilakukan maksimal 7 hari dari tanggal transaksi pembelian. Transaksi yang telah melewati 7 hari dari tanggal transaksi dilakukan oleh Pembeli, tidak dapat diklaim untuk dilakukan retur dan mendapatkan pengembalian stok.
            </li>
            <li type="a">
              Pembeli wajib menyertakan bukti transaksi dengan tambahan yang diminta oleh penujual untuk melakukan validasi klaim agar dapat dilakukan retur atas transaksi yang tidak valid.
            </li>
            <li type="a">
              Pembeli berhak memastikan proses retur telah dilakukan dengan baik oleh penjual dengan memeriksa mutasi stok secara berkala.
            </li>
            <li type="a">
              Bila karena kondisi tertentu proses retur mengalami kendala, irsmarket.com akan membantu mencarikan alternatif solusi untuk dikomunikasikan.
            </li>
          </ol>
          <span class="h1-modal"><strong>10. PENARIKAN DANA</strong></span>
          <ol>
            <li type="a">
              Penarikan dana dari irsmarket.com oleh pembeli hanya dapat dilakukan jika dalam keadaan-keadaan tertentu berikut ini:
              <ol>
                <li>
                  <p>
                    Pembeli melakukan kesalahan dalam menentukan tujuan transfer. Akibat kelalaian pembeli tersebut, dana yang dapat ditarik adalah kelebihan dari Rp. 1.000.000
                  </p>
                </li>
                <li>
                  <p>
                    Pembeli menyatakan mengundurkan dari dari irsmarket.com dan tidak akan bertransaksi kembali selama layanan irsmarket.com masih beroperasi. Karenanya pembeli dapat melakukan penarikan dana dengan nilai kelebihan dari Rp. 100.000
                  </p>
                </li>
              </ol>
            </li>
            <li type="a">
              Pembeli tidak dapat melakukan penarikan dana selain dari pada ketentuan poin a (1), (2) dan (3) tersebut di atas.
            </li>
            <li type="a">
              Peranikan dana oleh penjual sebagai hak atas penjualan produk yang di terima dapat dilakukan sebanyak banyaknya kelebihan dari Rp. 50.000
            </li>
            <li type="a">
              Penarikan dana dapat dilakukan pada setiap hari pukul 08.00 s/d 21.00 WIB
            </li>
            <li type="a">
              Penarikan dana akan di proses ke rekening pengguna yang telah di daftarkan di irsmarket.com
            </li>
            <li type="a">
              Irsmarket.com tidak bertanggung jawab atas terjadinya kesalahan pengiriman dana yang diakibatkan oleh kelalaian pengguna dalam penginputan data di irsmarket.com
            </li>
          </ol>
          <span class="h1-modal"><strong>11. LAYANAN PENGGUNA</strong></span>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Untuk memberikan layanan yang optimal, pihak irsmarket  dapat dihubungi pada alamat, nomor telepon dan email berikut ini pada jam operasional (kerja) 08:00 WIB – 17:00 WIB.<br/>
            Departemen Layanan Pelanggan
            Gedung Perkantoran MNC Lt. 4 Blok a/c Jalan Diponegoro No 109 Denpasar Bali <br/>
          </p>
          <table style="margin-left: 36px;">
            <tr>
              <td>
                <b>Telepon</b>
              </td>
              <td>:</td>
              <td>
                <b>(+62361) 232045</b>
              </td>
            </tr>
            <tr>
              <td>
                <b>Email</b>
              </td>
              <td>:</td>
              <td><b>info@aviana.co.id</b></td>
              <td>
                <b></b>
              </td>
            </tr>
          </table>
          <span class="h1-modal"><strong>12. PENYELESAIAN PERSELISIHAN</strong></span>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Setiap perbedaan pendapat dan atau perselisihan yang timbul, diusahakan untuk diselesaikan secara musyawarah untuk mufakat.
          </p>
          <span class="h1-modal"><strong>13. PERUBAHAN SYARAT DAN KETENTUAN</strong></span>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Irsmarket.com berhak melakukan kebijaksanaan untuk memodifikasi, mengubah, menambah, atau mengganti salah satu dari Syarat dan Ketentuan Penjualan setiap saat tanpa pemberitahuan terlebih dahulu. Silahkan periksa halaman ini secara berkala untuk perubahan.
          </p>
        </div>
</div>
</template>

<script>
export default {
  name: 'SyaratKetentuanPanel'
}
</script>
